module.exports = __webpack_public_path__ + "img/BIT_white22.fc20a9ce.jpg";